<div class="expand" [class.open]="isOpen">
  <div class="header">
    <ng-content select="[header]"> </ng-content>
    <button
      type="button"
      class="btn btn-primary expand-close pointer py-2 px-3"
      (click)="toggleOpen()"
    >
      <i class="fal fa-times"></i>
    </button>
  </div>

  <div class="content">
    <ng-content></ng-content>
  </div>

  <div class="footer">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>

<div class="expand-overlay" *ngIf="isOpen" (click)="close()"></div>
